<template>
  <ez-confirmation-modal ref="orderConfirmation" icon="question">
    <template #title>{{ acceptText }}?</template>
    <template #content>
      <p>Please review before confirming that you accept this quote.</p>
    </template>
    <template #footer>
      <ez-button
        type="link"
        @click="close"
        :data-cy="commonCy.SINGLE_ORDER.ACCEPT_ORDER_MODAL.BUTTON__CANCEL"
      >
        Cancel
      </ez-button>
      <ez-button
        @click="approveOrder"
        :data-cy="commonCy.SINGLE_ORDER.ACCEPT_ORDER_MODAL.BUTTON__ACCEPT"
      >
        {{ acceptText }}
      </ez-button>
    </template>
  </ez-confirmation-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { EzConfirmationModal } from '@/components/ui/Modal';
import EzButton from '@/components/ui/Button';
import flash from '@/components/ui/FlashMessage';
import { COMMON as commonCy } from '@orderez/qa-utils/dist/orderEz/common';

/**
 * AcceptOrder
 * @version 1.0.0
 * @since 2.0.0
 */
export default {
  components: {
    EzConfirmationModal,
    EzButton,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmMessage: '',
      commonCy,
    };
  },
  computed: {
    acceptText() {
      return 'Accept Quote';
    },
  },
  methods: {
    ...mapActions('entities/orders', ['publicOrderActions']),
    open() {
      this.$refs.orderConfirmation.open();
    },
    close() {
      this.$refs.orderConfirmation.close();
    },
    async approveOrder() {
      const config = {
        headers: {
          'X-Public-Token': this.token,
        },
      };
      const data = {
        message: this.confirmMessage,
        declinedProducts: this.excludedProductsIds,
      };
      await this.publicOrderActions({
        id: this.order.id,
        action: 'accept-quote',
        type: 'venue',
        config,
        data,
      });
      this.$emit('success');
      this.close();
      this.confirmMessage = '';

      flash.success({
        title: 'Quote accepted.',
        message: 'You have successfully accepted the quote.',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .notes {
  margin-bottom: 12px;
}
</style>
